/**
 * When routeMode is provided, the key distinguishes the canonical v2 mergeability entry.
 * Omit routeMode for prefix-based invalidation that targets all mergeability entries for a PR.
 */
export function mergeabilityStatusQueryKey(
  owner: string,
  repo: string,
  number: string,
  routeMode: 'v2',
): readonly ['mergeability-status', string, string, string, 'v2'];
export function mergeabilityStatusQueryKey(
  owner: string,
  repo: string,
  number: string,
): readonly ['mergeability-status', string, string, string];
export function mergeabilityStatusQueryKey(
  owner: string,
  repo: string,
  number: string,
  routeMode?: 'v2',
) {
  const prefix = ['mergeability-status', owner.toLowerCase(), repo.toLowerCase(), number] as const;
  return routeMode ? ([...prefix, routeMode] as const) : prefix;
}
